import React, { useState, useEffect } from "react"
import moment from 'moment-jalaali'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'
import MeasurementTypeDoubleBox from '../../Shared/MeasurementTypeDoubleBox'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const item = { categoryId: '', brandId: '', itemId: '', quantity: 0 }

export default ({ touched, errors, setFieldValue, values, handleBlur }) => {
  const [detailsShow, setDetailsShow] = useState(false)
  const [detailsData, setDetailsData] = useState([])

  const handleDetailsShow = model => {


    let details = values.previousOutputs.filter(el => el.taskOperationId === model.taskOperationId)
    console.log(details);

    setDetailsData(details)

    setDetailsShow(true)

  }

  return (
    <>
      <div className="row display-flex">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>محصولات تولید شده در شیفت های قبلی</legend>
            {values.previousOutputs && values.previousOutputs.length > 0 ?
              <table className="table validator-table" style={{ marginBottom: 5 }}>
                <thead>
                  <tr>
                    <th className="text-center">ردیف</th>
                    <th className="text-center">دسته بندی</th>
                    <th className="text-center">برند</th>
                    <th className="text-center">نام کالا</th>
                    <th className="text-center">مقدار تولید شده</th>
                    <th className="text-center">شیفت</th>
                    <th className="text-center">مسئول شیفت</th>
                    <th className="text-center">تاریخ ثبت</th>
                  </tr>
                </thead>
                <tbody>
                  {values.previousOutputs && values.previousOutputs.filter(el => el.taskOperationProductType === 1 && el.product.category.categoryClass === 0).map((item, index) => (
                    <tr key={"p-" + index} onClick={() => handleDetailsShow(item)} className="pointer">
                      <td>{index + 1}</td>
                      <td>
                        {item.product && item.product.category.name}
                      </td>
                      <td>
                        {item.product && item.product.brand.name}
                      </td>
                      <td>
                        {item.product && item.product.name}
                      </td>
                      <td>
                        {item.product !== undefined &&
                          <div className="flex-col flex-center">
                            <MeasurementTypeDoubleBox
                              product={item.product}
                              value={item.quantity}
                              onlySub
                            />
                          </div>
                        }
                      </td>
                      <td className="text-center">
                        <div className="shift">{item.shift}</div>
                      </td>
                      <td>
                        {item.user ? item.user.fullName : ''}
                      </td>
                      <td>
                        {moment(item.createdAt, "YYYY/M/D H:m").format("jYYYY/jM/jD ساعت H:mm")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              :
              <p className="text-center">موردی برای نمایش یافت نشد</p>
            }
          </fieldset>
        </div>
      </div>

      <Dialog
        open={detailsShow}
        onClose={() => setDetailsShow(false)}
        TransitionComponent={Transition}
        scroll={'paper'}
        fullWidth={true}
        maxWidth="lg"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description">
        <DialogTitle>
          <Fab color="secondary" aria-label="refresh" size="small" onClick={() => setDetailsShow(false)} className="modal-close-btn">
            <MdClose size="20px" />
          </Fab>
          <span style={{ marginRight: 10 }}></span>
        </DialogTitle>
        <DialogContent dividers={true}

        >
          <DetailsForm
            data={detailsData}
          />
        </DialogContent>
      </Dialog>


    </>
  )
}

const DetailsForm = props => {

  const [inputs, setInputs] = useState(undefined)
  const [outputs, setOutputs] = useState(undefined)

  useEffect(() => {

    if (props.data) {
      setInputs(props.data.filter(el => el.taskOperationProductType === 0))
      setOutputs(props.data.filter(el => el.taskOperationProductType === 1))
    }

  }, [props.data])


  return (
    inputs !== undefined && outputs !== undefined &&
    <>
      <div className="row display-flex">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>کالاهای نیمه ساخته بکار رفته در این شیفت</legend>
            <table className="table validator-table" style={{ marginBottom: 5 }}>
              <thead>
                <tr>
                  <th className="text-center">ردیف</th>
                  <th className="text-center">دسته بندی</th>
                  <th className="text-center">برند</th>
                  <th className="text-center">نام کالا</th>
                  <th className="text-center">مقدار بکار رفته سالم</th>
                  <th className="text-center">ضایعات</th>
                  <th className="text-center">مسئول شیفت</th>
                  <th className="text-center">تاریخ ثبت</th>
                </tr>
              </thead>
              <tbody>
                {inputs && inputs.map((input, index) => (
                  <tr>
                    <td>{1}</td>
                    <td>
                      {input.product && input.product.category.name}
                    </td>
                    <td>
                      {input.product && input.product.brand.name}
                    </td>
                    <td>
                      {input.product && input.product.name}
                    </td>
                    <td>
                      {input.product !== undefined &&
                        <MeasurementTypeDoubleBox
                          product={input.product}
                          value={input.quantity}
                        />
                      }
                    </td>
                    <td>
                      {input.product !== undefined &&
                        <MeasurementTypeDoubleBox
                          product={input.product}
                          value={input.waste}
                        />
                      }
                    </td>
                    <td>
                      {input.user ? input.user.fullName : ''}
                    </td>
                    <td>
                      {moment(input.createdAt, "YYYY/M/D H:m").format("jYYYY/jM/jD ساعت H:mm")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </fieldset>
        </div>
      </div>

      <div className="row display-flex">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>محصولات تولید شده در این شیفت</legend>
            <table className="table validator-table" style={{ marginBottom: 5 }}>
              <thead>
                <tr>
                  <th className="text-center">ردیف</th>
                  <th className="text-center">دسته بندی</th>
                  <th className="text-center">برند</th>
                  <th className="text-center">نام کالا</th>
                  <th className="text-center">مقدار تولید شده</th>
                  <th className="text-center">مسئول شیفت</th>
                  <th className="text-center">تاریخ ثبت</th>
                </tr>
              </thead>
              <tbody>
                {outputs && outputs.map((output, index) => (
                  <tr>
                    <td>{1}</td>
                    <td>
                      {output.product && output.product.category.name}
                    </td>
                    <td>
                      {output.product && output.product.brand.name}
                    </td>
                    <td>
                      {output.product && output.product.name}
                    </td>
                    <td>
                      {output.product !== undefined &&
                        <div className="flex-col flex-center">
                          {output.product != undefined &&
                            <MeasurementTypeDoubleBox
                              product={output.product}
                              value={output.quantity}
                              onlySub
                            />
                          }
                          {/* <span>
                          {(output.quantity + (output.product.measurementType !== undefined
                            ? ' (' + measurementTypes.filter(el => el.value === output.product.measurementType)[0].label + ')'
                            : ''))}
                        </span> */}
                        </div>
                      }
                    </td>
                    <td>
                      {output.user ? output.user.fullName : ''}
                    </td>
                    <td>
                      {moment(output.createdAt, "YYYY/M/D H:m").format("jYYYY/jM/jD ساعت H:mm")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </fieldset>
        </div>
      </div>

      <div className="row display-flex">
        <div className="col-lg-2 col-md-2 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>شیفت</legend>
            <div className="shift">{outputs[0].shift}</div>
          </fieldset>
        </div>
        <div className="col-lg-10 col-md-10 col-sm-12 col-xs-12">
          <fieldset className="fieldset">
            <legend>توضیحات</legend>
            {outputs[0].description}
          </fieldset>
        </div>
      </div>
    </>
  )
}